import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Landing from "@/components/Landing";
import Admin from "@/components/Admin";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={<Landing />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
